import { render } from "./UiFilter.vue?vue&type=template&id=d108f836&scoped=true&ts=true"
import script from "./UiFilter.vue?vue&type=script&lang=ts"
export * from "./UiFilter.vue?vue&type=script&lang=ts"

import "./UiFilter.vue?vue&type=style&index=0&id=d108f836&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d108f836"]])

export default __exports__